module.exports = __webpack_public_path__ + "img/miss文.6f24e16.png";